import { IColumnProps } from 'devextreme-react/data-grid';
import { GetFieldOptions } from 'shared/types';
import { FIRST_COLUMN, SECOND_COLUMN } from '../constants';

export const getFields = ({
  customizeText,
  customizeCaptions,
}: GetFieldOptions): IColumnProps[] => [
  {
    dataField: 'name',
    width: '60%',
    caption: customizeCaptions && customizeCaptions[FIRST_COLUMN],
  },
  {
    dataField: 'value',
    width: '40%',
    customizeText,
    caption: customizeCaptions && customizeCaptions[SECOND_COLUMN],
  },
];
